import { render, staticRenderFns } from "./draggable_tree.vue?vue&type=template&id=bc2c4422&scoped=true"
import script from "./draggable_tree.vue?vue&type=script&lang=js"
export * from "./draggable_tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2c4422",
  null
  
)

export default component.exports